import { useEffect, useState } from 'react'
import {
  Flex,
  Heading,
  Box,
} from '@chakra-ui/react'

import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import TabelaPublicacoesRejeitadas from './tabela-aviso-publicacoes-rejeitadas';
import Paginacao from '../../../../components/common/paginacao/paginacao';
import * as api from '../../../../api/avisoNecessidadeAtuacao';

const AvisoPublicacoesRejeitadas = () => {
  const [publicacoesRejeitadas, setPublicacoesRejeitadas] = useState<any[]>([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState<boolean>(false);
  const [idUsuario, setIdUsuario] = useState<number>(0);

  useEffect(() => {
    const dadosLocalStorage = localStorage.getItem("dadosUsuario");
    if (dadosLocalStorage) {
      try {
        const usuario = JSON.parse(dadosLocalStorage);
        setIdUsuario(usuario.seqUsuario);
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }
  }, []);
  
  useEffect(() => {
    if (!idUsuario) return;
  
    const fetchNecesidadeAtuacao = async () => {
      setLoading(true);
      try {
        const data = await api.avisoPublicacoesRejeitadas(paginaAtual, idUsuario, itemsPerPage);
        
        const avisosPublicacoesRejeitadas = data.formatoArquivos.map((avisos: any) => ({
          codPendencia: avisos.codPendencia,
          codTipoPublicacao: avisos.conteudoDTO.codTipoPublicacao,
          pendenciaDTO: avisos.pendenciaDTO,
          conteudoDTO: avisos.conteudoDTO,
          datRegistro: avisos.datRegistro,
          dataPublicacao: avisos.datPublicacao,
          seqConteudo: avisos.seqConteudo,
          solicitante: avisos.solicitante.dscNome,
          codRede: avisos.conteudoDTO?.contasRedeSocial?.[0]?.codRede ?? null
        }));
        
        setPublicacoesRejeitadas(avisosPublicacoesRejeitadas);
        setTotalPages(data.totalPaginas || 1);
      } catch (error) {
        console.error('Erro ao buscar avisos Necessidade Atuacao:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchNecesidadeAtuacao();
  }, [idUsuario, paginaAtual, itemsPerPage]);

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        mb="60px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
      Avisos de publicações rejeitadas   
    </Heading>

      <Box>
        <TabelaPublicacoesRejeitadas 
          listaAvisoPublicacoesRejeitadas={publicacoesRejeitadas} 
          listaVazia="Nenhum dado disponível." 
          loading={loading}
        />
      </Box>

      <Paginacao 
        paginaAtual={paginaAtual} 
        totalPages={totalPages} 
        onPageChange={setPaginaAtual}
      />
    </Flex>
  )
}

export default AvisoPublicacoesRejeitadas
